var normalizeComponent = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./artist_details.vue"
/* template */
import __vue_template__ from "!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1788c796\",\"hasScoped\":false}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./artist_details.vue"
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/shared/components/artist_details.vue
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 14 15 16 17 18 19 26 29 30 31 32 33 34 36 40 44 51 70 83 84 86 87 88 91 92 95 97 99 101 102 107 108 111 113 114 115 117 120 124 127 135 140 143 144 158 161 164 165 180 215 217 218 224 248 256 265 361